import { render, staticRenderFns } from "./full-thanks.vue?vue&type=template&id=0e3b8f4a&scoped=true"
import script from "./full-thanks.vue?vue&type=script&lang=js"
export * from "./full-thanks.vue?vue&type=script&lang=js"
import style0 from "./full-thanks.vue?vue&type=style&index=0&id=0e3b8f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b8f4a",
  null
  
)

export default component.exports